<template>
  <div class="card mb-3">
    <div class="card-header">
      <i class="fa fa-user-circle-o"></i>
      <span v-if="!prospect">{{ $t('member.title') }}</span>
      <span v-if="prospect">{{ $t('prospect.title') }}</span>

      <createButton v-if="!prospect" name="members_create" :title="$t('member.create.title')"></createButton>
      <createButton
        v-if="prospect && !junior"
        name="prospects_create"
        :title="$t('prospect.create.title')"
      ></createButton>

      <!-- <button text v-on:click="createAllActiveRegularMemberUsers" >Créer les accès au membres (intranet)</button>
      <br />
      <button text v-on:click="sendAllActiveRegularMemberUsersEmail" >Envoyer les courriel d'accès aux membres (intranet)</button> -->
    </div>
    <div class="card-body">
      <errorMessage v-bind:message="error"></errorMessage>

      <div class="form-group row" v-if="!prospect">
        <label
          for="staticEmail"
          class="col-sm-2 col-form-label"
        >{{ $t('member.form.visualisation.title') }}</label>
        <div class="col-sm-10">
          <select
            id="memberStatus"
            v-model="visualisation"
            @change="visualisationChange()"
            class="form-control"
            name="memberStatus"
          >
            <option value="0">{{ $t('member.form.visualisation.regular') }}</option>
            <option value="1">{{ $t('member.form.visualisation.status') }}</option>
            <!--option value=2>{{ $t('member.form.visualisation.reference') }}</option-->
            <option value="3">{{ $t('member.form.visualisation.expertise') }}</option>
            <option value="4">{{ $t('member.form.visualisation.interest') }}</option>
            <option value="5">{{ $t('member.form.visualisation.demographie') }}</option>
            <option value="6">{{ $t('member.form.visualisation.competency') }}</option>
            <option value="8">{{ $t('member.form.visualisation.activity') }}</option>
          </select>
        </div>
      </div>

      <hr />

      <div class="table-responsive">
        <table
          class="table table-bordered table-striped"
          id="dataTable"
          width="100%"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th class="status reference">{{ $t('member.form.id') }}</th>
              <th
                class="regular status reference expertise interest demographie competency activity"
              >{{ $t('member.form.familyName') }}</th>
              <th
                class="regular status reference expertise interest demographie competency activity"
              >{{ $t('member.form.name') }}</th>
              <th class="demographie">{{ $t('member.form.designation') }}</th>
              <th class="demographie drop-down-filter">{{ $t('address.form.region') }}</th>
              <th class="regular status expertise competency">{{ $t('member.form.email') }}</th>
              <th class="regular status expertise">{{ $t('member.table.phone') }}</th>
              <th class="regular drop-down-filter" v-if="!prospect">{{ $t('member.form.type') }}</th>
              <th
                class="regular date-range-filter"
                v-if="!prospect"
              >{{ $t('member.form.memberSince') }}</th>
              <th
                class="regular date-range-filter"
                v-if="!prospect"
              >{{ $t('member.form.membershipRenewalDate') }}</th>
              <th class="regular drop-down-filter" v-if="prospect">{{ $t('member.form.recruiter') }}</th>
              <th
                class="regular drop-down-filter"
                v-if="prospect"
                width="180"
              >{{ $t('member.form.changeOfBecomingMember') }}</th>
              <th
                class="regular status reference expertise interest demographie competency drop-down-filter activity"
              >{{ $t('member.form.status') }}</th>

              <!--th class="activity">{{ $t('member.form.activityOrganizer') }}</th-->
              <th class="activity">{{ $t('member.form.activityInscriptionsMontly') }}</th>
              <th class="activity">{{ $t('member.form.activityPresencesMontly') }}</th>
              <th class="activity">{{ $t('member.form.activityInscriptionsPitch') }}</th>
              <th class="activity">{{ $t('member.form.activityPresencesPitch') }}</th>
              <th class="activity">{{ $t('member.form.activityInscriptionsIntern') }}</th>
              <th class="activity">{{ $t('member.form.activityPresencesIntern') }}</th>

              <th class="demographie drop-down-filter">{{ $t('member.form.sex') }}</th>
              <th class="demographie">{{ $t('entrepreneur.form.immigrant') }}</th>
              <th
                class="demographie drop-down-filter"
              >{{ $t('entrepreneur.form.immigrantCountry') }}</th>
              <th class="demographie drop-down-filter">{{ $t('member.form.nativeLanguage') }}</th>
              <th class="demographie date-range-filter">{{ $t('member.form.birthdate') }}</th>

              <th>{{ $t('address.title') }}</th>

              <th>{{ $t('member.form.meetingLocation') }}</th>
              <th>{{ $t('member.form.type') }}</th>
              <th class="status date-range-filter">{{ $t('member.form.memberSince') }}</th>
              <th class="status date-range-filter">{{ $t('member.form.membershipRenewalDate') }}</th>
              <th>{{ $t('member.form.pricing') }}</th>
              <th
                class="status date-range-filter"
              >{{ $t('member.form.membershipCancellationDate') }}</th>
              <th
                class="status drop-down-filter"
              >{{ $t('member.form.membershipCancellationReason') }}</th>

              <th
                class="competency expertise drop-down-filter"
                width="400"
              >{{ $t('member.form.expertise') }}</th>
              <th
                class="competency interest drop-down-filter"
                width="400"
              >{{ $t('member.form.interest') }}</th>
              <th
                class="competency demographie drop-down-filter"
                width="400"
              >{{ $t('member.form.cell') }}</th>
              <th
                class="competency expertise drop-down-filter"
                width="400"
              >{{ $t('member.form.competencys') }}</th>

              <th class="reference">{{ $t('member.form.referredByMemberId') }}</th>
              <th class="reference">{{ $t('member.form.companys') }}</th>

              <!--th class="reference">{{ $t('member.form.godfatherId') }}</th-->
              <th>{{ $t('member.form.preAuthorizedDebit') }}</th>

              <th>{{ $t('member.form.junior.parentalAuthorization') }}</th>
              <th>{{ $t('member.form.junior.conductCode') }}</th>
              <th>{{ $t('member.form.junior.interview') }}</th>
              <th>{{ $t('member.form.junior.formation') }}</th>

              <th>{{ $t('member.form.subscribedToNewsletter') }}</th>
              <th>{{ $t('member.form.autorisationBio') }}</th>
              <th>{{ $t('member.form.emailAQ') }}</th>
              <th>{{ $t('member.form.photoConsent') }}</th>
              <th>{{ $t('member.form.businessCardAQ') }}</th>
              <th>{{ $t('social.followFacebook') }}</th>
              <th>{{ $t('social.followLinkedinGroup') }}</th>
              <th>{{ $t('social.followLinkedinProfile') }}</th>
              <th>{{ $t('social.socialNetworks') }}</th>

              <th>{{ $t('social.wordpress') }}</th>

              <th
                class="no-sort no-filter regular status reference expertise interest demographie"
                width="150"
                v-if="canCreate || canDelete"
              >&nbsp;</th>
              <th
                class="no-sort no-filter regular status reference expertise interest demographie"
                width="150"
                v-if="canCreate || canDelete"
              >&nbsp;</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th class="status reference">{{ $t('member.form.id') }}</th>
              <th
                class="regular status reference expertise interest demographie competency"
              >{{ $t('member.form.familyName') }}</th>
              <th
                class="regular status reference expertise interest demographie competency"
              >{{ $t('member.form.name') }}</th>
              <th class="demographie">{{ $t('member.form.designation') }}</th>
              <th class="demographie drop-down-filter">{{ $t('address.form.region') }}</th>
              <th class="regular status expertise competency">{{ $t('member.form.email') }}</th>
              <th class="regular status expertise">{{ $t('member.table.phone') }}</th>
              <th class="regular drop-down-filter" v-if="!prospect">{{ $t('member.form.type') }}</th>
              <th
                class="regular date-range-filter"
                v-if="!prospect"
              >{{ $t('member.form.memberSince') }}</th>
              <th
                class="regular date-range-filter"
                v-if="!prospect"
              >{{ $t('member.form.membershipRenewalDate') }}</th>
              <th class="regular drop-down-filter" v-if="prospect">{{ $t('member.form.recruiter') }}</th>
              <th
                class="regular drop-down-filter"
                v-if="prospect"
                width="180"
              >{{ $t('member.form.changeOfBecomingMember') }}</th>
              <th
                class="regular status reference expertise interest demographie competency drop-down-filter"
              >{{ $t('member.form.status') }}</th>

              <!--th class="activity">{{ $t('member.form.activityOrganizer') }}</th-->
              <th class="activity">{{ $t('member.form.activityInscriptionsMontly') }}</th>
              <th class="activity">{{ $t('member.form.activityPresencesMontly') }}</th>
              <th class="activity">{{ $t('member.form.activityInscriptionsPitch') }}</th>
              <th class="activity">{{ $t('member.form.activityPresencesPitch') }}</th>
              <th class="activity">{{ $t('member.form.activityInscriptionsIntern') }}</th>
              <th class="activity">{{ $t('member.form.activityPresencesIntern') }}</th>

              <th class="demographie drop-down-filter">{{ $t('member.form.sex') }}</th>
              <th class="demographie">{{ $t('entrepreneur.form.immigrant') }}</th>
              <th
                class="demographie drop-down-filter"
              >{{ $t('entrepreneur.form.immigrantCountry') }}</th>
              <th class="demographie drop-down-filter">{{ $t('member.form.nativeLanguage') }}</th>
              <th class="demographie date-range-filter">{{ $t('member.form.birthdate') }}</th>

              <th>{{ $t('address.title') }}</th>

              <th>{{ $t('member.form.meetingLocation') }}</th>
              <th>{{ $t('member.form.type') }}</th>
              <th class="status date-range-filter">{{ $t('member.form.memberSince') }}</th>
              <th class="status date-range-filter">{{ $t('member.form.membershipRenewalDate') }}</th>
              <th>{{ $t('member.form.pricing') }}</th>
              <th
                class="status date-range-filter"
              >{{ $t('member.form.membershipCancellationDate') }}</th>
              <th
                class="status drop-down-filter"
              >{{ $t('member.form.membershipCancellationReason') }}</th>

              <th
                class="competency expertise drop-down-filter"
                width="400"
              >{{ $t('member.form.expertise') }}</th>
              <th
                class="competency interest drop-down-filter"
                width="400"
              >{{ $t('member.form.interest') }}</th>
              <th
                class="competency demographie drop-down-filter"
                width="400"
              >{{ $t('member.form.cell') }}</th>
              <th
                class="competency expertise drop-down-filter"
                width="400"
              >{{ $t('member.form.competencys') }}</th>

              <th class="reference">{{ $t('member.form.referredByMemberId') }}</th>
              <th class="reference">{{ $t('member.form.companys') }}</th>

              <th>{{ $t('member.form.preAuthorizedDebit') }}</th>

              <!--th class="reference">{{ $t('member.form.godfatherId') }}</th-->

              <th>{{ $t('member.form.junior.parentalAuthorization') }}</th>
              <th>{{ $t('member.form.junior.conductCode') }}</th>
              <th>{{ $t('member.form.junior.interview') }}</th>
              <th>{{ $t('member.form.junior.formation') }}</th>

              <th>{{ $t('member.form.subscribedToNewsletter') }}</th>
              <th>{{ $t('member.form.autorisationBio') }}</th>
              <th>{{ $t('member.form.emailAQ') }}</th>
              <th>{{ $t('member.form.photoConsent') }}</th>
              <th>{{ $t('member.form.businessCardAQ') }}</th>
              <th>{{ $t('social.followFacebook') }}</th>
              <th>{{ $t('social.followLinkedinGroup') }}</th>
              <th>{{ $t('social.followLinkedinProfile') }}</th>
              <th>{{ $t('social.socialNetworks') }}</th>
              <th>{{ $t('social.wordpress') }}</th>

              <th
                class="no-sort no-filter regular status reference expertise interest demographie"
                width="150"
                v-if="canCreate || canDelete"
              >&nbsp;</th>
              <th
                class="no-sort no-filter regular status reference expertise interest demographie"
                width="150"
                v-if="canCreate || canDelete"
              >&nbsp;</th>
            </tr>
          </tfoot>
          <tbody>
            <tr
              v-for="member in entites"
              :key="member.id"
              v-bind:data-id="member.id"
              @click="view(member)"
              class="clickable-row"
            >
              <td>{{member.id}}</td>
              <td>{{member.familyName}}</td>
              <td>
                {{member.name}}
                <span class="imported_alert" v-if="member.imported">**</span>
              </td>
              <td>{{member.designation}}</td>
              <td class="drop-down-filter">{{member.address.regionText}}</td>
              <td>{{member.email}}</td>
              <td>
                <ul class="list-unstyled">
                  <li v-if="member.cellphone">
                    <i class="fa fa-fw fa-mobile" aria-hidden="true"></i>
                    {{member.cellphone}}
                  </li>
                  <li v-if="member.phone">
                    <i class="fa fa-fw fa-home" aria-hidden="true"></i>
                    {{member.phone}}
                  </li>
                  <li v-if="member.officePhone">
                    <i class="fa fa-fw fa-building" aria-hidden="true"></i>
                    {{member.officePhone}}
                    <span
                      v-if="member.officePhoneExtension"
                    >#</span>
                    {{member.officePhoneExtension}}
                  </li>
                </ul>
              </td>
              <td class="drop-down-filter" v-if="!prospect">
                <span v-if="member.birthdate != null && getPersonAge(member) < 18">
                  <i style="display:none">{{ $t('member.form.minor') }}</i>
                  <span class="fa fa-lg fa-id-card"></span>
                </span>
                {{member.typeText}}
              </td>
              <td v-if="!prospect">{{member.memberSince | formatDate }}</td>
              <td v-if="!prospect">{{member.membershipRenewalDate | formatDate}}</td>

              <td
                v-if="prospect"
              >{{ member.recruiterUser != null ? member.recruiterUser.fullName : member.recruiterMember != null ? member.recruiterMember.familyName + ', ' + member.recruiterMember.name : '' }}</td>
              <td v-if="prospect" align="center">{{ member.pourcentageOfBecomingMember }} %</td>

              <td class="drop-down-filter">
                <i
                  v-if="member.status==2"
                  class="fa fa-lg fa-check"
                  aria-hidden="true"
                  :title="member.statusText"
                ></i>
                <i
                  v-if="member.status==3"
                  class="fa fa-lg fa-ban"
                  aria-hidden="true"
                  :title="member.statusText"
                ></i>
                <i
                  v-if="member.status==4"
                  class="fa fa-lg fa-exclamation-triangle"
                  aria-hidden="true"
                  :title="member.statusText"
                ></i>
                <i
                  v-if="member.status==1"
                  class="fa fa-lg fa-commenting-o"
                  aria-hidden="true"
                  :title="member.statusText"
                ></i>
                <i
                  v-if="member.status==5 || member.status==6"
                  class="fa fa-lg fa-ban"
                  aria-hidden="true"
                  :title="member.statusText"
                ></i>
                {{member.statusText}}
              </td>

              <!--td>{{ member.activityOrganizer }}</td-->
              <td>{{ member.activityInscriptionsMontly }}</td>
              <td>{{ member.activityPresencesMontly }}</td>
              <td>{{ member.activityInscriptionsPitch }}</td>
              <td>{{ member.activityPresencesPitch }}</td>
              <td>{{ member.activityInscriptionsIntern }}</td>
              <td>{{ member.activityPresencesIntern }}</td>

              <td class="drop-down-filter">{{ member.sexText }}</td>
              <td>{{ member.immigrant | formatBoolean }}</td>
              <td>{{ member.immigrantCountry }}</td>
              <td class="drop-down-filter">{{ member.nativeLanguage }}</td>
              <td>{{ member.birthdate | formatDate }}</td>
              <td>{{ member.address | addressFormat }}</td>
              <td class="drop-down-filter">{{ member.meetingLocationText }}</td>
              <td class="drop-down-filter">{{ member.typeText }}</td>
              <td>{{ member.memberSince | formatDate }}</td>
              <td>{{ member.membershipRenewalDate | formatDate }}</td>

              <td class="drop-down-filter">{{ member.pricingText }}</td>
              <td>{{ member.membershipCancellationDate | formatDate }}</td>
              <td class="drop-down-filter">{{ member.MembershipCancellationReasonText }}</td>

              <td>
                <span v-for="comp in member.expertise">{{ comp.competency.name }},</span>
              </td>
              <td>
                <span v-for="comp in member.interest">{{ comp.competency.name }},</span>
              </td>
              <td>
                <span v-for="comp in member.cell">{{ comp.competency.name }},</span>
              </td>
              <td>
                <span v-for="comp in member.expertiseCompetency">{{ comp.competency.name }},</span>
              </td>

              <td>
                <span
                  v-if="member.referredByMember != null"
                >{{ member.referredByMember.familyName }}, {{ member.referredByMember.name }}</span>
              </td>
              <!--td>{{ member.godfatherId }}</td-->
              <td>{{ member.companyPersons }}</td>

              <td>{{ member.preAuthorizedDebit | formatBoolean }}</td>

              <td>{{ member.parentalAuthorization | formatBoolean }}</td>
              <td>{{ member.conductCode | formatBoolean }}</td>

              <td>{{ member.interview | formatDate }}</td>
              <td>{{ member.formation | formatDate }}</td>
              <td>{{ member.subscribedToNewsletter | formatBoolean }}</td>
              <td>{{ member.autorisationBio | formatBoolean }}</td>
              <td>{{ member.emailAQ | formatBoolean }}</td>
              <td>{{ member.photoConsent | formatBoolean }}</td>
              <td>{{ member.businessCardAQ | formatBoolean }}</td>
              <td>{{ member.followFacebook | formatBoolean }}</td>
              <td>{{ member.followLinkedinGroup | formatBoolean }}</td>
              <td>{{ member.followLinkedinProfile | formatBoolean }}</td>
              <td>{{ member.social != null ? member.social.socialNetworks : '' }}</td>
              <td>{{ member.social != null ? member.social.wordpress : '' }}</td>

              <td class="no-sort" align="center" v-if="canCreate || canDelete">
                <a
                  href="#"
                  v-if="canReallyCreate(member)"
                  v-bind:title="$t('form.edit_button')"
                  v-on:click.stop="edit(member)"
                >
                  <span class="fa fa-lg fa-pencil"></span>
                </a>
                <a href="#" v-else v-bind:title="$t('form.edit_button')">
                  <span class="fa fa-lg fa-pencil text-muted"></span>
                </a>
                &nbsp;
                <a
                  href="#"
                  v-if="canReallyCreate(member)"
                  v-bind:title="$t('form.copy_button')"
                  v-on:click.stop="copy(member)"
                >
                  <span class="fa fa-lg fa-copy"></span>
                </a>
                <a href="#" v-else v-bind:title="$t('form.copy_button')">
                  <span class="fa fa-lg fa-copy text-muted"></span>
                </a>
                &nbsp;
                <a
                  class="text-danger"
                  v-if="canReallyDelete(member)"
                  v-bind:title="$t('form.delete_button')"
                  href="#"
                  v-on:click.stop="deleteEntity(member.id)"
                >
                  <span class="fa fa-lg fa-trash"></span>
                </a>
                <a class="text-danger" v-else v-bind:title="$t('form.delete_button')">
                  <span class="fa fa-lg fa-trash text-muted"></span>
                </a>
                &nbsp;
                <a v-if="canReallyDelete(member) && member.associatedUserId != null"
                 v-on:click.stop="resendEmailConfirmation(member)"
                 title="ré-envoyer le courriel de confirmation"
                   href="#"
                >
                       <span class="fa fa-lg fa-envelope-o"></span>
                </a>
              </td>
               <td v-if="canCreate || canDelete">
                <div v-if="member.type != 2">

                  <button
                    class="btn btn-success"
                    v-if="member.associatedUserId == null "
                    v-on:click.stop="createMemberUser(member)"
                  >{{ $t('member.form.action.createMemberUser') }}</button>
                  <span  v-if="member.associatedUserId != null">
                    <strong>Accès intranet existant</strong>
                  </span>
                  <button
                    class="btn btn-warning mt-2"
                    v-if="member.mainDisplayInIntranet == false"
                    v-on:click.stop="focusInIntranet(member)"
                  >{{ $t('member.form.action.focusInIntranet') }}</button>
                  <button
                    class="btn btn-danger mt-2"
                    v-if="member.mainDisplayInIntranet == true"
                    v-on:click.stop="focusInIntranet(member)"
                  >{{ $t('member.form.action.removeFocusInIntranet') }}</button>
                 </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import {MemberServiceClient, CompetencyServiceClient, UserServiceClient, CreateUserDto} from '../../shared/service-clients/service-clients'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'
import permission from '../../shared/permission'

export default {
  name: 'Members',
  mixins: [SearchMixin],
  props: {
    prospect: false,
  },
  data() {
    return {
      serviceClient: MemberServiceClient,
      memberStatus: [],
      visualisation: 0,
      competencyTree: [],
      userServiceClient: UserServiceClient,
      data: [null, null, null, null, null, null, null],
    }
  },
  computed: {
    junior: function() {
      return permission.checkPermission(['Pages.Members.Junior.Seulement'])
    },
  },
  watch: {
    $route() {
      if ($.fn.DataTable.isDataTable('#dataTable')) {
        $('#dataTable')
          .DataTable()
          .destroy()
        $('#dataTable').hide()
      }

      this.fetchData()
    },
  },
  methods: {
    visualisationChange: function() {
      let self = this

      let showColumn = '.regular'

      if (this.visualisation == 0) {
        showColumn = '.regular'
      } else if (this.visualisation == 1) {
        showColumn = '.status'
      } else if (this.visualisation == 2) {
        showColumn = '.reference'
      } else if (this.visualisation == 3) {
        showColumn = '.expertise'
      } else if (this.visualisation == 4) {
        showColumn = '.interest'
      } else if (this.visualisation == 5) {
        showColumn = '.demographie'
      } else if (this.visualisation == 6) {
        showColumn = '.competency'
      } else if (this.visualisation == 8) {
        showColumn = '.activity'
      }

      this.fetchReportData(this.visualisation, self)
        .then(s => {
          self.entites = s

          // First time
          if (!$('#dataTable').is(':visible')) {
            self.showDataTable(
              {
                aaSorting: [[1, 'asc'], [2, 'asc']],
                sort: [[1, 'asc'], [2, 'asc']],
                columnDefs: [],
                fnDrawCallback: function(oSettings) {
                  let dataTable = $('#dataTable')
                  if (!dataTable.is(':visible')) {
                    dataTable.show()
                    self.fixColumns(showColumn)
                  }
                },
              },
              self
            )
          } else {
            self.fixColumns(showColumn)
            self.applyJqueryComponents()
          }
        })
        .catch(err => {
          debugger
          self.error = err
          reject()
        })
    },
    fixColumns: function(column) {
      let dt = $('#dataTable').DataTable()
      dt.columns().visible(false)
      dt.columns(column).visible(true)
    },
    fetchReportData: function(reportType, self) {
      return new Promise((resolve, reject) => {
        let type = self.prospect ? 2 : 1

        if (reportType != 2) reportType = 0 //  && reportType != 8

        if (self.data[reportType] == null) {
          let service = ServiceFactory.create(self.serviceClient)
          let getAll = service.getAll(parseInt(reportType) + 1, type, '', 0, 10000)
          getAll
            .then(res => {
              self.data[reportType] = res.items
              resolve(self.data[reportType])
            })
            .catch(err => {
              reject(self.getErrorMessage(err))
            })
        } else {
          resolve(self.data[reportType])
        }
      })
    },
    canReallyCreate: function(entite) {
      let junior = permission.checkPermission(['Pages.Members.Junior.Seulement'])
      if (!junior) return this.canCreate

      if (entite.type != 3 && junior) return false
      return true
    },
    canReallyDelete: function(entite) {
      let junior = permission.checkPermission(['Pages.Members.Junior.Seulement'])
      if (!junior) return this.canDelete

      if (entite.type != 3 && junior) return false
      return true
    },
    fetchData: function() {
      let service = ServiceFactory.create(this.serviceClient)
      let competencyServiceClient = ServiceFactory.create(CompetencyServiceClient)

      let self = this
      let type = this.prospect ? 2 : 1

      let getAll = service.getAll('', type, '', 0, 10000)
      let getCompetencys = competencyServiceClient.getAll(undefined, false, '', 0, 1000)

      let promisseAll = Promise.all([getAll, getCompetencys])

      getAll
        .then(res => {
          self.data[0] = res.items
        })
        .catch(err => {
          self.error = self.getErrorMessage(err)
        })

      getCompetencys
        .then(res => {
          self.competencyTree = res
        })
        .catch(err => {
          err
        })

      promisseAll.then(v => {
        let interest = this.flatCompetency(
          _.find(self.competencyTree.items, function(x) {
            return x.name == "INTÉRÊTS\nSECTEURS D'ACTIVITÉ"
          })
        )

        let cell = this.flatCompetency(
          _.find(self.competencyTree.items, function(x) {
            return x.name == 'CELLULES \nSECTORIELLES'
          })
        )
        let expertise = this.flatCompetency(
          _.find(self.competencyTree.items, function(x) {
            return x.name == "EXPERTISE\nSECTEURS D'ACTIVITÉ"
          })
        )

        let competency = this.flatCompetency(
          _.find(self.competencyTree.items, function(x) {
            return x.name == 'EXPERTISE\nCHAMPS DE COMPÉTENCE'
          })
        )

        for (var ix = 0; ix < self.data[0].length; ix++) {
          if (self.data[0][ix].competencys != null && self.data[0][ix].competencys.length > 0) {
            self.data[0][ix].interest = this.findCompetency(self.data[0][ix].competencys, interest)
            self.data[0][ix].cell = this.findCompetency(self.data[0][ix].competencys, cell)
            self.data[0][ix].expertise = this.findCompetency(self.data[0][ix].competencys, expertise)
            self.data[0][ix].expertiseCompetency = this.findCompetency(self.data[0][ix].competencys, competency)
          }
        }

        self.visualisationChange()
      })
    },
    flatCompetency: function(competency) {
      var r = []
      r.push(competency.id)
      _.forEach(competency.childCompetencys, childCompetencys => {
        r.push(childCompetencys.id)
        _.forEach(childCompetencys.childCompetencys, childCompetencys2 => {
          r.push(childCompetencys2.id)
        })
      })
      return r
    },
    findCompetency: function(competencys, type) {
      let filteredCompetency = []
      for (let i = 0; i < competencys.length; i++) {
        for (let j = 0; j < type.length; j++)
          if (competencys[i].competencyId == type[j]) {
            filteredCompetency.push(competencys[i])
          }
      }

      return filteredCompetency
    },

    getPersonAge: function(member) {
      if (member.birthdate != null) {
        return moment().diff(moment(member.birthdate), 'years')
      }
    },
    edit: function(membre) {
      this.redirect_to('_edit', membre)
    },
    view: function(membre) {
      this.redirect_to('_view', membre)
    },
    copy: function(membre) {
      this.redirect_to('_copy', membre)
    },
    redirect_to: function(path, membre) {
      let name = 'members'
      if (membre.type == 2) name = 'prospects'

      this.$router.push({name: name + path, params: {id: membre.id}})
    },
    createMemberUser: function(membre) {
      var input = new CreateUserDto()
      input.firstName = membre.name
      input.lastName = membre.familyName
      input.emailAddress = membre.email

      switch (membre.type) {
        case 1: {
          input.roleNames = ['Member']
          break
        }
        case 3: {
          input.roleNames = ['AQ Junior']
          break
        }
      }

      input.phoneNumber = membre.phone
      input.forIntranet = true
      input.entityType = 'Member'
      input.entityId = membre.id
      var self = this
      swal({
        title: 'Êtes-vous sûr?',
        text: 'Cette action va créer les accès intranet de ' + input.emailAddress + ' !',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(willSend => {
        if (willSend) {
          let userServiceClient = ServiceFactory.create(UserServiceClient)
          userServiceClient
            .create(input)
            .then(res => {
              membre.associatedUserId = res.id
              swal('Envoyé avec succès!', {
                icon: 'success',
              })
            })
            .catch(err => {
              var errorCodeName = JSON.parse(err.response).message
              var errorMessage = this.getErrorMessage(err)
              // This can be the only exception from this.
              var friendlyMessage = self.$t(`errors.duplicateUserName`)

              swal({
                title: 'Une erreur est survenu!',
                text: friendlyMessage,
                icon: 'error',
              })
              console.log(this.getErrorMessage(err))
            })
        }
      })
    },
    resendEmailConfirmation: function(member) {
      let userServiceClient = ServiceFactory.create(UserServiceClient)
      userServiceClient
        .resendEmailConfirmation({id: member.associatedUserId})
        .then(res => {
          swal('Envoyé avec succès!', {
            icon: 'success',
          })
        })
        .catch(err => {
          var errorCodeName = JSON.parse(err.response).message
          var errorMessage = this.getErrorMessage(err)
          // This can be the only exception from this.

          swal({
            title: 'Une erreur est survenu!',
            text: errorMessage,
            icon: 'error',
          })
          console.log(this.getErrorMessage(err))
        })
    },
    focusInIntranet: function(member) {
      let memberService = ServiceFactory.create(MemberServiceClient)
      member.mainDisplayInIntranet = !member.mainDisplayInIntranet
      memberService
        .toggleMainDisplayInIntranet(member)
        .then(res => {
          console.log('success')
        })
        .catch(err => {
          console.log(err)
        })
    },
    createAllActiveRegularMemberUsers: function() {
      swal({
        title: 'Voulez vous vraiment créer tout les accès?',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(willCreate => {
        if (willCreate) {
          let userServiceClient = ServiceFactory.create(UserServiceClient)
          userServiceClient
            .getAllActiveRegularMemberUsers('ac5a6e50-a9d2-4f43-981c-fd51e6dff0e7')
            .then(res => {
              swal('Accès créés avec succès', {
                icon: 'success',
              })
            })
            .catch(err => {
              var errorCodeName = JSON.parse(err.response).message
              var errorMessage = this.getErrorMessage(err)
              // This can be the only exception from this.
              console.log(this.getErrorMessage(err))
            })
        } else {
        }
      })
    },
    sendAllActiveRegularMemberUsersEmail: function() {
      swal({
        title: 'Voulez vous vraiment envoyé les courriels?',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(willCreate => {
        if (willCreate) {
          let userServiceClient = ServiceFactory.create(UserServiceClient)
          userServiceClient
            .getSendAllActiveRegularMemberIntranetAccessEmail('ac5a6e50-a9d2-4f43-981c-fd51e6dff0e7')
            .then(res => {
              swal('Courriels envoyés avec succès', {
                icon: 'success',
              })
            })
            .catch(err => {
              var errorCodeName = JSON.parse(err.response).message
              var errorMessage = this.getErrorMessage(err)
              // This can be the only exception from this.
              console.log(this.getErrorMessage(err))
            })
        } else {
        }
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.separator ~ .separator::before {
  content: ", ";
}
</style>




// WEBPACK FOOTER //
// src/components/members/Members.vue